<template>
    <!--    <div>В разработке</div>-->
    <ai-tree-node-load
        ref='tree'
        :meta="meta"
        :select-func-params-call-back="selectFuncParamsCallBack" />
</template>

<script setup>
import AiTreeNodeLoad from '@/components/ai-tree-node-load/ai-tree-node-load.vue';
import { ref } from 'vue';

const meta = ref({
    api: 'address./cities/get',
    keyExpr: 'kod_m',
    keyParent: 'k_npw',
    pathField: 'path',
    hasItemsField: 'has_items',
    columns: [
        {
            field: 'kod_m',
            caption: 'kod_m',
        },
        {
            field: 'guid',
            caption: 'ГУИД ГАР',
        },
        {
            field: 'okato',
            caption: 'ОКАТО',
        },
        {
            field: 'oktmo',
            caption: 'ОКТМО',
        },
        {
            field: 'ur',
            caption: 'Тип',
        },
    ],
    columnsLikes: ['name_s'],
    firstColumnFields: {
        text: 'name_s',
        svg: 'asset_svg',
        caption: 'Наименование',
    },
    sort: {
        field: 'path_names',
        order: 'asc',
    },
});
const tree = ref();
const selectFuncParamsCallBack = args => {
    console.log('selectFuncParamsCallBack(args): ', args);
    if (args.option === 'roots') {
        return {
            kod_m: null,
        };
    } else if (args.option === 'childes') {
        return {
            kod_m: args.keyExprValue,
        };
    } else if (args.option === 'find') {
        return { sel_all: true };
    }
};

</script>
<script>
export default {
    name: 'view-address-edit',
};
</script>
<style scoped></style>
